import { Component } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { faCirclePlus, faHistory, faHouse, faBarsProgress, faRightFromBracket, faPlay, faCloudArrowUp, faUser, faListCheck, faCircleInfo, faGear, faQuestionCircle, faComment } from '@fortawesome/free-solid-svg-icons';
import { MatDialog } from '@angular/material/dialog';
import { SettingsComponent } from '../settings/settings.component';
import { TaskModel } from '../task/task.model';
import { AuthService } from '../../core/auth/auth.service';


@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent {
  isAuthenticated: boolean = false;
  aquariusUri: string = "https://www.aquariuspowered.com";
  userData$: any;
  clientName: any = environment.clientName;
  currentComponent: any = {};
  logoUri: string = "./assets/logo_small_white.png";
  applicationVersion: string = environment.version;
  faCircleInfo = faCircleInfo;
  faCirclePlus = faCirclePlus;
  faHouse = faHouse;
  faBarsProgress = faBarsProgress;
  faRightFromBracket = faRightFromBracket;
  faPlay = faPlay;
  faCloudArrowUp = faCloudArrowUp;
  faUser = faUser;
  faListCheck = faListCheck;
  faHistory = faHistory;
  faGear = faGear;
  faQuestionCircle = faQuestionCircle;
  faComment = faComment;
  userSettingsDialogRef!: any;
  isAdmin: boolean = false;

  constructor(
    private breakpointObserver: BreakpointObserver,
    public activatedRoute: ActivatedRoute,
    private router: Router,
    public oidcSecurityService: OidcSecurityService,
    public dialog: MatDialog,
    public taskModel: TaskModel,
    public authService: AuthService
  ) {


  }

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );


  ngOnInit() {
    const router = this.router;
    this.oidcSecurityService.isAuthenticated$.subscribe(({ isAuthenticated }) => {
      this.isAuthenticated = isAuthenticated;
      console.warn('authenticated: ', isAuthenticated);
      this.userData$ = this.oidcSecurityService.userData$;
    });
  }

  login() {
    this.oidcSecurityService.authorize();
  }

  refreshSession() {
    this.oidcSecurityService.authorize();
  }

  logout() {
    sessionStorage["Sync"] = null;
    this.oidcSecurityService.logoff();
  }

  goTo(component: any) {
    this.router.navigateByUrl(component.url);
    this.currentComponent = component;
  }

  showUserSettings() {
    this.userSettingsDialogRef = this.dialog.open(SettingsComponent, { width: "400px" });
    this.userSettingsDialogRef.afterClosed().subscribe(() => {

    });
  }

  onAlphaTagClick() {

  }

  goToSupport() {
    window.open("https://cloudprocessing-landing.acustica-audio.com/help/");
  }

  onFeedbackTagClick() {
    const iframe = document.getElementById("launcher-frame") as any;
    const button = iframe.contentWindow.document.getElementsByClassName("launcher-button")[0] as HTMLElement;
    button.click();
  }
}
